import React, { useEffect, useRef, useState } from "react";
import "./Productyoutube.css";

const videoIds = [
    "3K2WUUen3e4",
    "x_atMFLV8yU",
    "BuaYqS-Vd60",
    "1MVlsehxzEk",
    "lzjrrhR6Ico"
];

const ProductYouTube = () => {
    const playerRefs = useRef({});
    const [pausedVideos, setPausedVideos] = useState(Array(videoIds.length).fill(false));

    useEffect(() => {
        if (!window.YT) {
            const tag = document.createElement("script");
            tag.src = "https://www.youtube.com/iframe_api";
            const firstScriptTag = document.getElementsByTagName("script")[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }

        window.onYouTubeIframeAPIReady = () => {
            videoIds.forEach((videoId, index) => {
                playerRefs.current[index] = new window.YT.Player(`youtube-player-${index}`, {
                    events: {
                        onStateChange: (event) => onPlayerStateChange(event, index),
                    },
                });
            });
        };

        return () => {
            window.onYouTubeIframeAPIReady = null;
        };
    }, []);

    const onPlayerStateChange = (event, index) => {
        setPausedVideos((prev) => {
            const updated = [...prev];
            updated[index] = event.data === 2; // 2 = paused
            return updated;
        });
    };

    return (
        <div className="hmsection4">
            <div className="row">
                <div className="col-lg-8 col-sm-12">
                    <div className="product-youtube-left-link-img-8 position-relative">
                        <iframe
                            id="youtube-player-0"
                            width="100%"
                            height="100%"
                            title="YouTube video player"
                            frameBorder="0"
                            loading="lazy"
                            src={`https://www.youtube.com/embed/${videoIds[0]}?origin=https://plyr.io&iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1`}
                            allowFullScreen
                            allow="autoplay"
                        ></iframe>
                        {pausedVideos[0] && <div className="overlay">Paused</div>}
                    </div>
                </div>

                <div className="col-lg-4 col-sm-12">
                    <div className="product-youtube-link-img-8">
                        {[1, 2].map((index) => (
                            <div key={index} className="position-relative">
                                <iframe
                                    id={`youtube-player-${index}`}
                                    width="100%"
                                    height="315"
                                    src={`https://www.youtube.com/embed/${videoIds[index]}?origin=https://plyr.io&iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1`}
                                    title="YouTube video player"
                                    frameBorder="0"
                                    allowFullScreen
                                    allow="autoplay"
                                ></iframe>
                                {pausedVideos[index] && <div className="overlay">Paused</div>}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <br />

            <div className="row">
                <div className="col-lg-6">
                    <div className="product-youtube-link-img-8 position-relative">
                        <iframe
                            id="youtube-player-3"
                            width="100%"
                            height="450"
                            src={`https://www.youtube.com/embed/${videoIds[3]}?origin=https://plyr.io&iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1`}
                            title="YouTube video player"
                            frameBorder="0"
                            allowFullScreen
                            allow="autoplay"
                        ></iframe>
                        {pausedVideos[3] && <div className="overlay">Paused</div>}
                    </div>
                </div>

                <div className="col-lg-6">
                    <div className="product-youtube-link-img-8 position-relative">
                        <iframe
                            id="youtube-player-4"
                            width="100%"
                            height="450"
                            src={`https://www.youtube.com/embed/${videoIds[4]}?origin=https://plyr.io&iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1`}
                            title="YouTube video player"
                            frameBorder="0"
                            allowFullScreen
                            allow="autoplay"
                        ></iframe>
                        {pausedVideos[4] && <div className="overlay">Paused</div>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductYouTube;
